"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealChildLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealChildLinear = function MealChildLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 8a6 6 0 013.736 10.695c.173.743.264 1.514.264 2.305 0 6.075-5.373 11-12 11S8 27.075 8 21c0-.79.091-1.562.264-2.305a6 6 0 118.534-8.299A13.037 13.037 0 0120 10c1.11 0 2.183.138 3.203.396A5.989 5.989 0 0128 8zm-8 14c-4.333 0-5.862 2.333-4.585 7 1.374.64 2.933 1 4.585 1 1.652 0 3.21-.36 4.584-1h.014c1.268-4.667-.265-7-4.598-7zm2 2c1.013 1-.996 4-2 4s-2.99-3.012-2-4c.66-.658 1.327-.492 2 .5.658-1 1.325-1.167 2-.5zm-2-12c-5.523 0-10 4.03-10 9 0 2.468 1.104 4.704 2.891 6.33C12.817 22.443 15.187 20 20 20c4.813 0 7.183 2.443 7.11 7.329C28.896 25.704 30 23.468 30 21c0-4.97-4.477-9-10-9zm4.5 5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-9 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM12 10a4 4 0 00-3.015 6.628c1.142-2.413 3.2-4.378 5.772-5.525A3.983 3.983 0 0012 10zm16 0c-1.07 0-2.04.42-2.758 1.103 2.573 1.147 4.631 3.112 5.773 5.525A4 4 0 0028 10z",
    fill: "#95A0B3"
  }));
};

exports.MealChildLinear = MealChildLinear;
var _default = MealChildLinear;
exports.default = _default;